import './UniWidgetColumnReport.scss';
import { Form } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export type UniWidgetColumnReportProps = {
    title: string,    
    options: UniWidgetColumnOptions[],
    currentSelectedFilter: number,
    filterOptions: UniWidgetColumnOptions[],
    onChangeFilter: (value: number) => void,
    columnReportHeight: number
};

export type UniWidgetColumnOptions = {
    value: number,
    description: string,
    code?: string
}

const UniWidgetColumnReport = (props: UniWidgetColumnReportProps) => {
    const { t } = useTranslation();

    const [currentFilterSelected, setCurrentFilterSelected] = useState(props.currentSelectedFilter);

    const [maxValue, setMaxValue] = useState(1);

    useEffect(() => {
        setMaxValue(Math.max(...props.options.map((x) => {
            return x.value
        })))
    }, [props.options]);

    useEffect(() => {
        setCurrentFilterSelected(props.currentSelectedFilter)
    }, [props.currentSelectedFilter]);

    const setCurrentFilter = (value: number) => {
        setCurrentFilterSelected(value);
        props.onChangeFilter(value);
    }

    const getCurrentFilterSelected = () => {
        return props.filterOptions.find(x => x.value === currentFilterSelected)?.description;
    }

    return (
        <>
            <div className='column-report-wrapper'>
                {
                    <>
                        <div className='d-flex justify-content-between column-report-header'>
                            <div className='d-flex column-report-title'>
                                <p className='title'>{props.title}</p>
                                <p className='subtitle'> - {t('widgetColumnReport.view')} {getCurrentFilterSelected()}</p>
                            </div>
                            <div className='filter-select'>
                                <Form.Select
                                    onChange={(e) => {
                                        setCurrentFilter(parseInt(e.target.value));
                                    }}
                                    value={currentFilterSelected}
                                    >
                                    {
                                        props.filterOptions?.map((option, idx) => {
                                            return (
                                                <option key={idx} value={option.value}>{option.description}</option>
                                            )
                                        })
                                    }
                                </Form.Select>
                            </div>
                        </div>
                        <div className='d-flex justify-content-left items-graph-wrapper'>
                            <div className='items'>
                            {
                                props.options?.map((option, idx) => {
                                    return (
                                        <div key={idx} className='item-graph-wrapper' style={{ height: props.columnReportHeight + 'px'}}>
                                            <p className='value'>
                                                {option?.value ?? 0} t
                                            </p>
                                            <div
                                                className='item-graph'
                                                style={{
                                                    height: ((option?.value / maxValue) * props.columnReportHeight) + 'px' ?? 0,
                                                    maxHeight: props.columnReportHeight + 'px',
                                                    backgroundColor: idx & 1 ? '#02FF3E' : '#0F8A38'
                                                }}
                                                >
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            </div>
                            <div className='columns'>
                            {
                                props.options?.map((option, idx) => {
                                    return (
                                        <p key={idx} className="description"><span>{option.code}</span> {option.description}</p>
                                    )
                                })
                            }
                            </div>
                        </div>
                    </>
                }
            </div>
        </>
    )
}

export default UniWidgetColumnReport;